module.exports = __webpack_public_path__ + "img/alarm.5eea862e.png";